<script lang="ts">
    import '../../../../tailwind.css';
    import type { TWordpressShellAndFooterTranslations } from '$lib/services/wordpress/types';
    import type { TMarket } from '$lib/services/market/types';
    import TopBar from './TopBar.svelte';
    import BottomBar from './BottomBar.svelte';
    import Footer from './Footer/Footer.svelte';
    import { getContext, type Snippet } from 'svelte';
    import { page } from '$app/state';
    import { getItems } from './utils';
    import { notificationStore } from '$lib/stores/notifications';
    import { fromStore } from 'svelte/store';
    import { afterNavigate } from '$app/navigation';

    type Props = {
        market: TMarket;
        isLoggedIn: boolean;
        translations: TWordpressShellAndFooterTranslations;
        children: Snippet;
        rgBarSlot: Snippet;
    };

    let { market, isLoggedIn, translations, children, rgBarSlot }: Props = $props();
    let vertical = getContext<{ current: 'casino' | 'sports' }>('vertical');
    let notifications = fromStore(notificationStore);
    let computedItems = $state(
        getItems(translations, vertical.current, market, notifications.current)
    );
    afterNavigate(() => {
        computedItems = getItems(translations, vertical.current, market, notifications.current);
    });
    let { verticalNavItems, ...items } = $derived(computedItems);
</script>

<div class="fabric-shell bg-grey-0 pb-[var(--bottom-bar-height)]">
    {#if market.hasRgHeader}
        <div class="fixed top-0 z-[10] h-[var(--rg-height,theme(spacing.lg))] w-screen">
            {@render rgBarSlot()}
        </div>
    {/if}
    <TopBar
        {items}
        verticalItems={verticalNavItems}
        showVerticals={market.isSportsEnabled}
        {isLoggedIn}
        {market}
    />
    {#if !page.data.isNative}
        <BottomBar {market} {isLoggedIn} {items} />
    {/if}
    <div class="min-h-[90vh]">
        {@render children()}
    </div>
    <Footer {market} translations={translations.footer} />
</div>

<style>
    .fabric-shell :global([component='ModuleMenu']) {
        display: none;
    }
</style>
